import apiClient from '@/lib/api';

export interface Randonneur {
  id: number;
  randobr_id: string | null;
  cognito_sub: string;
  cpf: string;
  nome: string;
  sobrenome: string | null;
  email: string;
  telefone: string | null;
  data_nascimento: string | null;
  sexo: string | null;
  cep: string | null;
  logradouro: string | null;
  numero: string | null;
  complemento: string | null;
  bairro: string | null;
  cidade: string | null;
  estado: string | null;
  pais: string | null;
  cognito_group: string;
  status: 'ativo' | 'suspenso' | 'inativo' | 'banido';
}

export interface UpdateRandonneurInput {
  nome?: string;
  sobrenome?: string;
  telefone?: string;
  data_nascimento?: string;
  sexo?: string;
  cep?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  pais?: string;
}

export async function getMe(): Promise<Randonneur> {
  const response = await apiClient.get<Randonneur>('/randonneurs/me');
  return response.data;
}

export async function updateMe(id: number, data: UpdateRandonneurInput): Promise<Randonneur> {
  const response = await apiClient.put<Randonneur>(`/randonneurs/${id}`, data);
  return response.data;
}
